<app-load-nav [activeMenuItem]="'annual-fee'"></app-load-nav>

<mat-card class="content-card" *ngIf="currentUserIsAdmin()">
  <mat-card-content>
    <div *ngIf="isStatsLoading">
      <mat-progress-bar mode="indeterminate" class="progress-bar"></mat-progress-bar>
    </div>
    <div style="width: 100%;" *ngIf="culpaStats && !isStatsLoading">
      <div fxFlex="10">
        <div class="sts-box" style="text-align: center; border: 1px solid grey;">
          Total Culpa<br />
          {{ culpaStats.totalCulpa | number: '1.2-2' }}
        </div>
      </div>

      <div fxFlex="10">
        <div class="sts-box" style="text-align: center; border: 1px solid grey;">
          Total Culpa Lawyer<br />
          {{ culpaStats.totalCulpaLawyer | number: '1.2-2' }}
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>


<mat-card class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h5>No invoices linked</h5>
    </mat-card-title>
  </mat-card-header>

  <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">

    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="tableNotLinked">
        <mat-form-field class="search-field">
          <input #searchFieldNotLinked matInput (keydown.enter)="onSearchNotLinked(searchButtonNotLinked.disabled)" placeholder="Search" [(ngModel)]="tableNotLinked.filters.str">
        </mat-form-field>
        <button #searchButtonNotLinked mat-icon-button (click)="onSearchNotLinked()">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="clearFilterTableNotLinked()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <app-mat-table-generator #tableNotLinked
                           [defaultSortField]="'transactionDate'"
                           [defaultSortDirection]="'desc'"
                           tableName="revolutTransactionLegTable-notlinked"
                           [useEmbededFilter]="false"
                           [columns]="columnsNotLinked"
                           [dataSource]="dataSourceNotLinked"
                           [editEnabled]="false"
                           [deleteEnabled]="currentUserIsAdmin()"
                           [multiselectEnabled]="false"
                           [viewLink]="getViewLinkNotLinked"
                           [saveFilters]=true
  >
  </app-mat-table-generator>
</mat-card>

<mat-card class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h5>Invoices linked</h5>
    </mat-card-title>
  </mat-card-header>

  <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">

    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
        <mat-form-field class="search-field">
          <input #searchField matInput (keydown.enter)="table.applyFilter()" placeholder="Search" [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="table.applyFilter()">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="table.clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <app-mat-table-generator #table
                           [defaultSortField]="'transactionDate'"
                           [defaultSortDirection]="'desc'"
                           tableName="revolutTransactionLegTable"
                           [useEmbededFilter]="false"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="false"
                           [deleteEnabled]="false"
                           [viewLink]="getViewLink"
                           [multiselectEnabled]="false"
                           [saveFilters]=true
  >
  </app-mat-table-generator>
</mat-card>
